import { Box, Button, Card, CardContent, Stack, Typography } from '@mui/material';
import PlaceIcon from '@mui/icons-material/Place';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import EmailIcon from '@mui/icons-material/Email';
import { cardStyles, metaStripStyles, venueStyles } from './eventDetailsStyles';

const EventVenueCard = ({ venue, locationLabel, mapsUrl }) => {
  const hasVenueDetails = Boolean(
    venue?.name || venue?.address || venue?.phone || venue?.email || locationLabel || venue?.map_embed_url || mapsUrl,
  );

  if (!hasVenueDetails) {
    return null;
  }

  return (
    <Card sx={cardStyles.section}>
      <CardContent>
        <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 2 }}>
          <PlaceIcon sx={metaStripStyles.icon} />
          <Typography variant="h6" sx={{ fontWeight: 700 }}>Venue &amp; Location</Typography>
        </Stack>
        <Box sx={venueStyles.panel}>
          {venue?.name && <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>{venue.name}</Typography>}
          <Stack spacing={0.75} sx={{ mt: venue?.name ? 1 : 0 }}>
            {(venue?.address || locationLabel) && (
              <Stack direction="row" spacing={1} alignItems="center">
                <PlaceIcon fontSize="small" />
                <Typography variant="body2">{venue?.address || locationLabel}</Typography>
              </Stack>
            )}
            {venue?.phone && (
              <Stack direction="row" spacing={1} alignItems="center">
                <LocalPhoneIcon fontSize="small" />
                <Typography variant="body2">{venue.phone}</Typography>
              </Stack>
            )}
            {venue?.email && (
              <Stack direction="row" spacing={1} alignItems="center">
                <EmailIcon fontSize="small" />
                <Typography variant="body2">{venue.email}</Typography>
              </Stack>
            )}
          </Stack>
        </Box>
        {venue?.map_embed_url && (
          <Box>
            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} justifyContent="space-between" alignItems={{ xs: 'stretch', sm: 'center' }} sx={venueStyles.mapHeader}>
              <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>Location Map</Typography>
              {mapsUrl && (
                <Button size="small" variant="outlined" href={mapsUrl} target="_blank" rel="noreferrer">Open in Google Maps</Button>
              )}
            </Stack>
            <Box component="iframe" src={venue.map_embed_url} sx={venueStyles.map} loading="lazy" />
          </Box>
        )}
      </CardContent>
    </Card>
  );
};

export default EventVenueCard;
